<template>
  <VModal>
    <VSpan slot="header" class="header-text" :text="title" :size="16" :weight="TextWeight.bold" />
    <VP slot="contents" class="content-text" :color="TextColor.disable" :text="message" :size="16" />
    <VBlock slot="footer" class="button-wrapper">
      <VButton class="cancel-button" :color="ButtonColor.none" :onClick="onCancel">
        <VSpan text="취소" :size="14" />
      </VButton>
      <VButton class="ok-button" :color="ButtonColor.none" :onClick="onOK">
        <VSpan text="확인" :size="14" />
      </VButton>
    </VBlock>
  </VModal>
</template>

<script>
import VButton, { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VP from '@/presentationals/v2/components/layouts/atoms/VP'
import VSpan, { TextColor, TextWeight } from '@/presentationals/v2/components/layouts/atoms/VSpan'

import VBlock from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VModal from '@/presentationals/v2/components/layouts/molecules/VModal'

export default {
  name: 'ModalConfirm',
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    }
  },
  components: {
    VButton,
    VSpan,
    VP,

    VBlock,
    VModal
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.header-text,
.content-text {
  text-align: center;
  letter-spacing: -0.38px;
  line-height: 1.38;
}

.button-wrapper {
  border-top: 1px solid $light-gray-2;
  width: 100%;
  height: 50px;
  border-spacing: 0 0;
  border-collapse: collapse;

  .cancel-button {
    border-right: 1px solid $light-gray-5;
  }

  .cancel-button,
  .ok-button {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-top: 1px solid $white;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
    }
  }
}
</style>